import urls from '../api_urls/inciBasfMark'
import { _post, _upload } from '@/axios/request'
import $axios from '@/axios/config.js'

// 获取列表
export function getInciList (params) {
  return _post(urls.GET_LIST, params)
}

// 修改状态
export function updateInci (params) {
  return _post(urls.UPDATE_INCI, params)
}

// 导入
export function uploadInci (params) {
  return _upload(urls.UPLOAD, params)
}

// 下载
export function downloadInci (params) {
  return $axios({
    url: urls.DOWNLOAD,
    method: 'get',
    params,
    responseType: 'arraybuffer'
  })
}



// WEBPACK FOOTER //
// ./src/axios/api/inciBasfMark.js